import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: "How do I know you'll actually show up?",
    a: "Jose's is a local Monterey business with a real reputation on the line. We show up — on time, ready to work."
  }, {
    q: 'Do you handle really big jobs?',
    a: 'Yes. From a single item to a full hoarder cleanout or construction site — we scale to the job.'
  }, {
    q: "What if I don't know how much stuff I have?",
    a: "Just call and describe it. We'll give you a straightforward estimate. No surprises."
  }, {
    q: 'Do you take everything?',
    a: 'Furniture, appliances, concrete, dirt, green waste, construction debris, specialty items — the answer is almost always yes.'
  }, {
    q: 'How fast can you come out?',
    a: "Often same-day or next-day. Call (831) 240-7401 and we'll get you scheduled fast."
  }, {
    q: 'Is this more expensive than renting a dumpster?',
    a: "When you factor in rental fees, your time, your labor, dump fees, and multiple trips — Jose's is often the smarter investment."
  }, {
    q: 'Do you serve my area?',
    a: "If you're within 50 miles of Monterey, CA — most likely yes. Call and confirm in 30 seconds."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-[#F9F9F9]" data-id="element-91">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="text-center mb-12" data-id="element-93">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-94">
            FREQUENTLY ASKED <span className="text-[#C8102E]" data-id="element-95">QUESTIONS</span>
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-96">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-97">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-98">
                <span className="font-bold text-lg text-[#1A1A1A]" data-id="element-99">
                  {faq.q}
                </span>
                <ChevronDown className={`text-[#C8102E] transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} size={24} data-id="element-100" />
              </button>
              <AnimatePresence data-id="element-101">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-102">
                    <div className="px-6 pb-4 text-gray-600 border-t border-gray-100 pt-4" data-id="element-103">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}